import { TimelineMarker, TimelineRow } from '../TimelineData';

export function obtainFreeRowForMarker(rows: TimelineRow[], marker: TimelineMarker): TimelineRow {
  for (const row of rows) {
    if (row.markers.length === 0) {
      return row;
    }

    const lastMarker = row.markers[row.markers.length - 1];
    if (lastMarker.endTimeMs) {
      if (marker.startTimeMs > lastMarker.endTimeMs) {
        return row;
      }
    } else {
      const minAllowedDurationBetweenEventsInOneRowMSec = 50;
      const allowedStartMs = lastMarker.startTimeMs + minAllowedDurationBetweenEventsInOneRowMSec;
      if (marker.startTimeMs > allowedStartMs) {
        return row;
      }
    }
  }

  const newRow: TimelineRow = {
    markers: [],
  };
  rows.push(newRow);
  return newRow;
}
